module.exports = __webpack_public_path__ + "img/feedback-share-your-wisdom.9543db4e.png";